import { IgrColumn } from "./igr-column";
import { PinnedPositions_$type } from "./PinnedPositions";
import { ColumnPinnedChangedEventArgs as ColumnPinnedChangedEventArgs_internal } from "./ColumnPinnedChangedEventArgs";
import { ensureEnum } from "igniteui-react-core";
/**
 * Event arguments for the ColumnPinnedChanged event.
*/
var IgrColumnPinnedChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrColumnPinnedChangedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrColumnPinnedChangedEventArgs.prototype.createImplementation = function () {
        return new ColumnPinnedChangedEventArgs_internal();
    };
    Object.defineProperty(IgrColumnPinnedChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrColumnPinnedChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrColumnPinnedChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrColumnPinnedChangedEventArgs.prototype, "column", {
        /**
         * The column whose pinned state has changed.
        */
        get: function () {
            if (this.i.a == null) {
                return null;
            }
            if (!this.i.a.externalObject) {
                var e = IgrColumn._createFromInternal(this.i.a);
                if (e) {
                    e._implementation = this.i.a;
                }
                this.i.a.externalObject = e;
            }
            return this.i.a.externalObject;
        },
        set: function (v) {
            v == null ? this.i.a = null : this.i.a = v.i;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrColumnPinnedChangedEventArgs.prototype, "pinned", {
        /**
         * The new pinned state for the column.
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = ensureEnum(PinnedPositions_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    return IgrColumnPinnedChangedEventArgs;
}());
export { IgrColumnPinnedChangedEventArgs };
//# sourceMappingURL=igr-column-pinned-changed-event-args.js.map
